/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ailoaderstepfinishing3Inputs */

const en_ailoaderstepfinishing3 = /** @type {(inputs: Ailoaderstepfinishing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finishing up`)
};

const de_ailoaderstepfinishing3 = /** @type {(inputs: Ailoaderstepfinishing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird abgeschlossen`)
};

/**
* | output |
* | --- |
* | "Finishing up" |
*
* @param {Ailoaderstepfinishing3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ailoaderstepfinishing3 = /** @type {((inputs?: Ailoaderstepfinishing3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ailoaderstepfinishing3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ailoaderstepfinishing3(inputs)
	return de_ailoaderstepfinishing3(inputs)
});
export { ailoaderstepfinishing3 as "aiLoaderStepFinishing" }